import React, {useEffect} from 'react';
import {Box, Typography} from '@mui/material';
import SteddiContainer from "../General/SteddiContainer";
import SectionHeader from "../General/SectionHeader";
import SteddiInfoItem from "../General/SteddiInfoItem";
import {Coins, HeartHandshake, LineChart, Scroll} from "lucide-react";
import PageHeader from "../General/PageHeader";
import Grid2 from "@mui/material/Unstable_Grid2";
import SteddiButton from "../General/SteddiButton";
import {ReactComponent as CompleteIcon} from "../../images/Bestilling.svg"
import useErrorStore from "../../stores/errorStore";
import EnergiKonto from "../Esign/InfoItems/EnergiKonto";
import useOrderState from "../../stores/orderStore";
import {useNavigate} from "react-router-dom";
import DateHelpers from "../../helpers/DateHelpers";
import useAppState from "../../stores/appStateStore";
import {getRedirectUrl} from "../../helpers/orderHelpers";

function CancelCompleted() {
  const setError = useErrorStore((state) => state.setError)
  const error = useErrorStore((state) => state.error)
  const redirectBrand = useAppState((state) => state.redirectBrand)
  const navigate = useNavigate()
  const orderState = useOrderState((state) => state)

  function handleNext() {
    window.location.href = getRedirectUrl(redirectBrand)
  }

  useEffect(() => {
    if (orderState.account === null) {
      setError({detail: "Invalid state, this page is no longer available", title: "Invalid state", status: 404, traceId: ""})
    }
  }, [orderState.account])

  useEffect(() => {
    if (error)
      navigate("error")
  }, [error])

  function getInvoiceDate() : Date {
    const today = new Date()
    return DateHelpers.getNextBusinessDay(new Date(today.getFullYear(), today.getMonth() + 1, 1))
  }

  return (
    <Box pt={5}>
      <Box display="flex" alignItems="center" justifyContent="center" mb={5}>
        <CompleteIcon/>
      </Box>
      <PageHeader>Avbestillingen er fullført</PageHeader>

      <Grid2 xs={12} container spacing={3}>
        <Grid2 xs={12}>
          <SectionHeader isSmol>Oppsummering</SectionHeader>
        </Grid2>
        <Grid2 xs={12}>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <EnergiKonto/>
          </SteddiContainer>
        </Grid2>
        <Grid2 xs={12}>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <SteddiInfoItem icon={<LineChart/>} bgColor={"secondary"}
                            title={"Din saldo"}
                            subtitle={<Typography sx={{fontSize: "24px", fontWeight: "bold", letterSpacing: 2, mb: -0.5}}>{(orderState.account?.currentBalance ?? 0).toLocaleString()} KR</Typography>}/>
          </SteddiContainer>
        </Grid2>
        <Grid2 xs={12}>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <SteddiInfoItem icon={<Scroll/>} bgColor={"secondary"}
                            title={"Opphørsfaktura lages"}
                            subtitle={DateHelpers.toDateString(getInvoiceDate())}/>
          </SteddiContainer>
        </Grid2>
        <Grid2 xs={12}>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <SteddiInfoItem title="AvtaleGiro eller eFaktura" subtitle="Opprett AvtaleGiro eller eFaktura i nettbanken din for å unngå fakturagebyr."
                            color={"primary"} bgColor={"secondary"} icon={<Coins/>}/>
          </SteddiContainer>
        </Grid2>
        {/*TODO: Enable again :)*/}
        {/*<Grid2 xs={12}>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <SteddiInfoItem title="Angre avbestilling" subtitle="Hvis du ombestemmer deg kan du enkelt bestille Forutsigbar Betaling igjen hos strømleverandøren din."
                            color={"primary"} bgColor={"secondary"} icon={<HeartHandshake/>}/>
          </SteddiContainer>
        </Grid2>*/}
      </Grid2>
      <Grid2 mt={5} container justifyContent="flex-end">
        <Grid2 xs={12} sm="auto">
          <SteddiButton onClick={handleNext}>Ferdig</SteddiButton>
        </Grid2>
      </Grid2>
    </Box>
  )
}

export default CancelCompleted